export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/SylndrSwift.5599d7f1.svg","height":26,"width":79,"blurWidth":0,"blurHeight":0};